module.exports = __webpack_public_path__ + "img/顶部搜素图标.6018d5bd.png";